import CreateEnterpriseProvider from '@enterprise/contexts/createEnterpriseContext';
import { EnterpriseForm } from './EnterpriseForm';

const CreateEnterprisePage = () => {
  return (
    <CreateEnterpriseProvider>
      <EnterpriseForm data-qa="enterprise-form" mode="create" />
    </CreateEnterpriseProvider>
  );
};

export default CreateEnterprisePage;
